import { render, staticRenderFns } from "./MoleculeEditionBillingAcademyProyectCard2.vue?vue&type=template&id=a69353f6"
import script from "./MoleculeEditionBillingAcademyProyectCard2.vue?vue&type=script&lang=js"
export * from "./MoleculeEditionBillingAcademyProyectCard2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports